<template>
	<form @submit.prevent="save">
		<vs-card class="flex flex-col justify-between p-5" fixedHeight style="min-height: 70vh">
			<ResponseAlert ref="response" />			
			<vs-row vs-justify="space-between" class="pt-5">
				<div class="w-full md:w-1/4 lg:w-2/12 mb-5 md:mb-0 lg:pr-2">
					<img :src="getUrlOfFile(vars.image)" alt="image-profile" class="w-3/4 md:w-full block m-auto">
					<vs-button color="primary" type="border" icon="upload_file" class="w-full mt-3" @click="$refs.file_upload.click()">
						<span class="text-xs">Upload Photo</span>
					</vs-button>
					<input ref="file_upload" type="file" accept="image/png, image/gif, image/jpeg, image/jpg"
						v-on:change="AddPhoto" hidden />
				</div>
				<div class="w-full md:w-1/3 lg:w-5/12 lg:px-3">
					<div class="w-full mb-5">
						<vs-input 
								autocomplete="off"
								v-validate="'required'" 
								label="Name" 
								name="name" 
								type="text"
								v-model="models.name" 
								class="w-full"/>
						<span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
					</div>
					<div v-if="!$route.params.id" class="w-full mt-5">
						<vs-input 
								autocomplete="off"
								v-validate="'required|email'" 
								label="Email" 
								name="email" 
								type="email"
								v-model="models.email" 
								class="w-full"/>
						<span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
					</div>
					<!-- <div class="w-full my-5">
						<label class="pl-2 text-sm" for="role">Role</label>
						<v-select
							id="role"
							:clearable="false"
							v-model="models.roleId"
							:reduce="role => role.value" 
							:options="masters.roles"
							label="text"
						/>
					</div> -->
					<div v-if="$route.params.id" class="w-full my-5">
						<label class="pl-2 text-sm" for="status">Status</label>
						<ul id="status" class="flex mt-3">
							<li>
								<vs-radio v-model="models.isActive" vs-name="status" :vs-value="true" class="mr-5">Active</vs-radio>
							</li>
							<li>
								<vs-radio v-model="models.isActive" vs-name="status" :vs-value="false">Inactive</vs-radio>
							</li>
						</ul>
						<span class="text-danger text-sm" v-show="errors.has('status')">{{ errors.first('status') }}</span>
					</div>
				</div>
				<div class="w-full md:w-1/3 lg:w-5/12 lg:pl-3">
					<div v-if="!$route.params.id" class="w-full mb-5 mt-5 md:mt-0 relative">
						<vs-input 
                @keydown.space.prevent
								autocomplete="off"
								v-validate="vars.role_password" 
								label="Password" 
								name="password" 
								:type="vars.type.password"
								v-model="models.password" 
								class="w-full"/>
            <vs-icon icon-pack="feather" @click="togglePassword" icon="icon icon-eye" class="absolute cursor-pointer" style="top: 30px; right: 10px"></vs-icon>

						<span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
					</div>
					
					<!-- <div v-if="!$route.params.id" class="w-full my-5">
						<label class="pl-2 text-sm" for="status">Status</label>
						<ul id="status" class="flex mt-3">
							<li>
								<vs-radio v-model="models.isActive" vs-name="status" :vs-value="true" class="mr-5">Active</vs-radio>
							</li>
							<li>
								<vs-radio v-model="models.isActive" vs-name="status" :vs-value="false">Inactive</vs-radio>
							</li>
						</ul>
						<span class="text-danger text-sm" v-show="errors.has('status')">{{ errors.first('status') }}</span>
					</div> -->
				</div>
			</vs-row>

			<div slot="footer" class="justify-center">
				<vs-button button="submit" color="primary" type="filled" class="mr-3">Save</vs-button>
				<vs-button @click="$router.go(-1)" color="rgb(172,172,172)" type="border">Cancel</vs-button>
			</div>
		</vs-card>
	</form>
</template>

<script>
	import api from '@/utils/api.js'
  import {mapState} from 'vuex'
	import {
		getUrlOfFile,
		uploadFile
	} from '@/utils/helpers.js';

	export default {
		name: 'FormAdmin',
		data() {
			return {
				config: {
					uri: this.$route.meta.link,
				},
				models: {
					name: "",
					image: "",
					email: "",
					password: "",
					roleId: null,
					isActive: true,
				},
				// masters: {
				// 	roles: [
				// 		{
				// 			value: null,
				// 			text: 'Select role'
				// 		}
				// 	]
				// },
				vars: {
					role_password: 'min:8',
					image: null,
					type: {
						password: 'password'
					}
				},
				getUrlOfFile
			}
		},
		created() {
      this.getById()
		},
		methods: {
			getById() {
        this.$axios.get(`${api.admins}/${this.AppActiveUser.admin.id}`)
          .then(res => {
            const { data } = res.data;
            this.models.name = data.name;
            this.vars.image = data.image;
            this.models.email = data.account.email;
            this.models.roleId = data.roleId;
            this.models.isActive = data.isActive;
          }).catch(() => this.$router.push({
            name: 'page404'
          }));
			},
			AddPhoto(event) {
				let fileSizeLimit = 1024 * 1024 * 2; // limit 2 MB
				if(event.target.files[0].size < fileSizeLimit) {
					this.vars.image = event.target.files[0];
				} else {
					this.$showToast('Failed', `Max file size is 2 MB`, 'danger')
				}
			},
			togglePassword() {
				this.vars.type.password = this.vars.type.password === 'password' ? 'text' : 'password'
			},
			save() {
				this.$validator.validate().then(async valid => {
				if (valid) {
					// get file image url
					this.models.image = typeof this.vars.image === 'string' ? this.vars.image : await uploadFile(this.vars.image)

          let models = {
            name: this.models.name,
            email: this.models.email,
            roleId: this.models.roleId,
            isActive: this.models.isActive,
            image: this.models.image
          }

					if(this.models.password !== '') {
						models.password = this.models.password
					}

          this.$axios.put(`${api.admins}/${this.AppActiveUser.admin.id}`, models).then(() => {
							this.$showToast('Success', `Success update profile`)
							setTimeout(() => {
								window.location.reload()
							}, 500);
						})
						.catch(error => this.$refs.response.setResponse(error.response.data, 'danger'));
				} else {
					window.scrollTo(0, 0);
				}
			});
			}
		},
    computed: {
      ...mapState(['AppActiveUser'])
    }
	}
</script>